
export const inputStyles = {
  control: {
    backgroundColor: '#fff',
    fontWeight: 'normal',
  },

  '&multiLine': {
    control: {},
    highlighter: {
      padding: 20,
      border: '1px solid transparent',
    },
    input: {
      padding: 9,
      paddingRight: 40,
      border: '1px solid silver',
      outline: 'none',
      borderRadius: 4,
      color: 'inherit',
    },
  },

  '&singleLine': {
    display: 'inline-block',
    width: 180,
    height: 30,

    highlighter: {
      padding: 1,
      border: '2px inset transparent',
    },
    input: {
      padding: 1,
      border: '2px inset',
    },
  },

  suggestions: {
    zIndex: 1002,
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
    },
    item: {
      padding: '8px 16px',
      '&focused': {
        backgroundColor: '#cee4e5',
      },
    },
  },
}
